import { api } from "@/lib/api";

const withTenant = (params, tenantId) =>
  tenantId ? { ...(params || {}), tenant_id: tenantId } : params;

export const ExamTypesAPI = {
  list: (institution_id, tenantId) =>
    api.get("/gradebook/exam-types", { params: withTenant({ institution_id }, tenantId) }).then((r) => r.data),
  create: (body, tenantId) =>
    api.post("/gradebook/exam-types", body, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  remove: (id, tenantId) =>
    api.delete(`/gradebook/exam-types/${id}`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
};

export const ExamsAPI = {
  list: (params, tenantId) =>
    api.get("/gradebook/exams", { params: withTenant(params, tenantId) }).then((r) => r.data),
  create: (body, tenantId) =>
    api.post("/gradebook/exams", body, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  remove: (id, tenantId) =>
    api.delete(`/gradebook/exams/${id}`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  getMarks: (eid, tenantId) =>
    api.get(`/gradebook/exams/${eid}/marks`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
  saveMarks: (eid, entries, tenantId) =>
    api.post(`/gradebook/exams/${eid}/marks`, { entries }, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
};

export const StudentSummaryAPI = {
  get: (sid, tenantId) =>
    api.get(`/gradebook/students/${sid}/summary`, { params: withTenant(undefined, tenantId) }).then((r) => r.data),
};
